export enum FeatureFlagName {
  fAndBDLCIStep = 'fAndBDLCIStep',
  fullstory = 'fullstory',
  maintenanceSplash = 'maintenanceSplash',
  offerAndSwapNotifications = 'offerAndSwapNotifications',
  pendo = 'pendo',
  realtimeRooms = 'realtimeInventory',
  realtimeRoomsNewTaskStatuses = 'realtimeInventoryNewTaskStatuses',
  realtimeRoomsPortfolio = 'realtimeInventoryPortfolio',
  shiftSwapNotes = 'shiftSwapNotes',
  shiftSwapRequests = 'shiftSwapRequests',
  tasks = 'tasks',
  taskNotifications = 'taskNotifications',
  inspectedRoomStatus = 'inspectedRoomStatus',
}

export type FeatureFlags = Record<FeatureFlagName, boolean>;
